<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		Text,
		IconButton,
		Container,
		ListNumberCard,
		Icon,
		Stack,
	} from '@Shelly/shelly-design-system';
	import { createActionJob } from 'src/helpers/actions/local/core/local_action_helpers';
	import {
		getLocalActionURL,
		getURLParams,
		setURLParams,
	} from 'src/helpers/actions/local/core/local_action_parse_url_helpers';
	//Types
	import type { Device } from '../../../../../types/Device';
	import { createEventDispatcher } from 'svelte';

	export let urls: string[], device: Device;

	const dispatcher = createEventDispatcher(),
		onClickLocalInputField = (url: string, urlIndex: number): void => {
			dispatcher('action', {
				urlIndex,
				localAction: getURLParams(url),
			});
		};
</script>

<Text element="h2" class="text-capitalize mb-s">
	{$format('text_title_local_actions', { default: 'Local actions' })}
</Text>
<Container type="borderDashed">
	<Stack gap="s">
		{#each urls as url, i}
			{#if /http:\/\/(127.0.0.1|localhost)\/rpc\//.test(url)}
				<ListNumberCard size="s" editMode>
					<Icon size="s" icon="fa-solid fa-location-dot" class="mr-s" />
					<Text styleType="body-small" class="width-full text-bold">
						{@html getLocalActionURL(url, device)}
					</Text>
					<IconButton
						aria-label={$format('button_edit_local_action', {
							default: 'Button edit local action',
						})}
						icon={'fas fa-pen'}
						variant="primary"
						class="mr-s"
						on:click={() => {
							onClickLocalInputField(url, i);
						}}
					/>
					<IconButton
						aria-label={$format('button_delete_local_action', {
							default: 'Button delete local action',
						})}
						icon={'fas fa-trash'}
						variant="danger"
						on:click={() => {
							url = '';
							if (urls.length > 1) {
								urls.splice(i, 1);
								urls = urls;
							}
						}}
					/>
				</ListNumberCard>
			{/if}
		{/each}

		<div class="flex-overflow-hidden justify-content-center">
			<IconButton
				class="max-width-full"
				icon="fas fa-plus"
				variant="secondary"
				disabled={urls.length > 4}
				on:click={() => {
					onClickLocalInputField(setURLParams(createActionJob(device)), urls.length);
				}}
			>
				{$format('button_add_local_action', {
					default: 'Add local action',
				})}
			</IconButton>
		</div>
	</Stack>
</Container>
